"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    wrapper: {
        position: 'relative',
        overflow: 'hidden',
    },
    image: function (_a) {
        var theme = _a.theme, radius = _a.radius;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { display: 'block', width: '100%', height: '100%', borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }), border: 0 }));
    },
    placeholderIcon: function (_a) {
        var theme = _a.theme, radius = _a.radius;
        return ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6],
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
            position: 'absolute',
            borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }),
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        });
    },
}, { link: true });
